// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"2c3702d6","211":"48a0b3a5","425":"dfc2e5cb"}[chunkId] + ".chunk.css";
};